import { useEffect, useRef } from 'react';

import { trackCalendlyMessage } from '../../lib/calendly';

interface CalendlyEmbedProps {
  className?: string;
}

export default function CalendlyEmbed({
  className = '',
}: CalendlyEmbedProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const tracked = useRef(new Set<string>());

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.head.appendChild(script);

    const handleCalendlyEvent = (event: MessageEvent) => {
      const frame = containerRef.current?.querySelector('iframe');
      trackCalendlyMessage(event, frame?.contentWindow, window.location.pathname, tracked.current,
        (name, params) => window.gtag?.('event', name, params), () => window.fbq?.('track', 'Lead'));
    };

    window.addEventListener('message', handleCalendlyEvent);

    return () => {
      window.removeEventListener('message', handleCalendlyEvent);

      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`w-full min-w-0 ${className}`}
    >
      <a href="https://calendly.com/noahblanchard/30min" target="_blank" rel="noopener noreferrer" className="sm:hidden flex items-center justify-center min-h-[48px] text-sm font-semibold underline underline-offset-4 text-[#806008] px-3">Open calendar in a full window</a>
      <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/noahblanchard/30min?hide_gdpr_banner=1&background_color=ffffff&text_color=111827&primary_color=d4a10d"
        style={{
          minWidth: '0px',
          width: '100%',
          height: '700px',
        }}
      />
      <p className="text-center text-sm text-gray-600 mt-3">
        Calendar not loading? <a href="https://calendly.com/noahblanchard/30min" target="_blank" rel="noopener noreferrer" className="underline text-[#806008]">Choose a time directly</a>.
      </p>
    </div>
  );
}
